import { Container } from '@mui/material';
import styles from './PageHeader.module.css';

interface IProps {
  title: string;
}

function PageHeader({ title }: IProps) {
  return (
    <div className={styles.pageHeader}>
      <Container className={styles.content}>{title}</Container>
    </div>
  );
}

export default PageHeader;
